module.exports = __webpack_public_path__ + "images/3-small.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/paypal/3-small.png
 ** module id = 560
 ** module chunks = 0
 **/